module.exports = __webpack_public_path__ + "static/media/road-show-banner.1767ab6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/RoadShowPage/assets/road-show-banner.png
// module id = 541
// module chunks = 0